var render = function render(){var _vm=this,_c=_vm._self._c;return _c('modal',[_c('div',{staticClass:"embed-modal",class:{ "has-aspect": !!_vm.aspectRatio }},[(!!_vm.aspectRatio)?_c('div',{staticClass:"shim",style:(_vm.aspectStyle)}):_vm._e(),_c('div',{staticClass:"embed",domProps:{"innerHTML":_vm._s(_vm.embed)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }